export const msgList = state => state.msgList
export const notifyCount = state => state.notifyCount
export const unReadMsg = state => state.unReadMsg
export const token = state => state.token
export const user = state => state.user
export const memberExt = state => state.memberExt
export const infoCompleteRate = state => state.infoCompleteRate
export const setting = state => state.setting
export const citys = state => state.citys
export const editAddress = state => state.editAddress
export const register = state => state.register
export const forget = state => state.forget
export const updatePhone = state => state.updatePhone
export const isCommunicate = state => state.isCommunicate
export const collection = state => state.collection
export const uploadFileMaxSize = state => state.uploadFileMaxSize
export const likeMsg = state => state.likeMsg
export const commentMsg = state => state.commentMsg
export const walletMsg = state => state.walletMsg
export const followMsg = state => state.followMsg
export const video = state => state.video
export const socialData = state => state.socialData
export const myPosition = state => state.myPosition
export const uploadTask = state => state.uploadTask
export const product = state => state.product
export const order = state => state.order
export const userInfo = state => state.userInfo
export const reward = state => state.reward
export const readArticleList = state => state.readArticleList
export const phone = state => state.phone



// WEBPACK FOOTER //
// ./src/store/getters.js